import { IPayload } from 'models/Global'
import {
  ICreateQuestionnaireParams,
  IGetQuestionnaireParams,
  IGetQuestionnairesParams,
  IPutQuestionnaireParams,
  IQuestionnaire,
} from '@src/features/questionnaires/questionnaires.types'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class QuestionnairesApi {
  constructor(private axios: AxiosService) {}

  getQuestionnaires = async (params: IGetQuestionnairesParams) => {
    const response = await this.axios.get<IPayload<IQuestionnaire[]>>(
      Endpoints.getQuestionnaires,
      params
    )
    return response
  }

  getQuestionnaire = async (id: number, params?: IGetQuestionnaireParams) => {
    const response = await this.axios.get<IPayload<IQuestionnaire>>(
      Endpoints.getQuestionnaire(id),
      params
    )
    return response
  }

  createQuestionnaire = async (params: ICreateQuestionnaireParams) => {
    const response = await this.axios.post<IPayload<IQuestionnaire>>(
      Endpoints.createQuestionnaire,
      params
    )
    return response
  }

  putQuestionnaire = async (id: number, params: IPutQuestionnaireParams) => {
    const response = await this.axios.put<IPayload<IQuestionnaire>>(
      Endpoints.putQuestionnaire(id),
      params
    )
    return response
  }
}
